import { TagButton, TagsFilterContainer } from './styled'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

const TagsFilter = ({
  tags,
  setTagIds,
  activeTags,
}: {
  tags: ITagsAndCategories
  setTagIds: (ids: number[]) => void
  activeTags: number[]
}) => {
  const router = useRouter()

  const handleTagClick = (tagId: number) => {
    const isActive = activeTags.includes(tagId)
    const newTags = isActive ? activeTags.filter((id) => id !== tagId) : [...activeTags, tagId]
    setTagIds(newTags)

    const query = { ...router.query }

    if (newTags.length > 0) {
      query.tags = newTags.join(',')
    } else {
      delete query.tags
    }

    router.replace(
      {
        pathname: router.pathname,
        query,
      },
      undefined,
      { shallow: true },
    )
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }, [activeTags])

  return (
    <TagsFilterContainer>
      {tags.tags.map((tag) => (
        <TagButton
          activeTag={activeTags.includes(tag.id)}
          key={tag.id}
          onClick={() => handleTagClick(tag.id)}
        >
          {tag.title}
          {activeTags.includes(tag.id) && (
            <CloseRoundedIcon fontSize="small" sx={{ marginLeft: '4px' }} />
          )}
        </TagButton>
      ))}
    </TagsFilterContainer>
  )
}

export default TagsFilter
